import React from 'react';

export const Footer: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-1">
            <h3 className="text-2xl font-bold mb-4 authority-brand-font">
              AI CONSULTING & AUTOMATION
            </h3>
            <p className="text-gray-300 mb-6">
              Transforming businesses through cutting-edge AI solutions, intelligent automation, and strategic consulting services that drive innovation and operational excellence.
            </p>
            <div className="mb-6">
              <h4 className="text-sm font-semibold text-gray-200 mb-2">Corporate Headquarters</h4>
              <p className="text-gray-400 text-sm">
                725 E Road 2 N Unit 1494<br />
                Chino Valley, AZ 86323
              </p>
            </div>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61587057361355" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-full cursor-pointer hover:bg-blue-700 transition-colors">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-pink-500 via-red-500 to-yellow-500 rounded-full cursor-pointer hover:opacity-80 transition-opacity">
                <i className="ri-instagram-fill text-lg"></i>
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-red-600 rounded-full cursor-pointer hover:bg-red-700 transition-colors">
                <i className="ri-youtube-fill text-lg"></i>
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-blue-700 rounded-full cursor-pointer hover:bg-blue-800 transition-colors">
                <i className="ri-linkedin-fill text-lg"></i>
              </div>
              <div className="w-10 h-10 flex items-center justify-center bg-black rounded-full cursor-pointer hover:bg-gray-800 transition-colors">
                <i className="ri-tiktok-fill text-lg"></i>
              </div>
            </div>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="/ai-strategy"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  AI Strategy Consulting
                </a>
              </li>
              <li>
                <a 
                  href="/process-automation"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Process Automation
                </a>
              </li>
              <li>
                <a 
                  href="/machine-learning"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Machine Learning Solutions
                </a>
              </li>
              <li>
                <a 
                  href="/digital-transformation"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Digital Transformation
                </a>
              </li>
              <li>
                <a 
                  href="/ai-implementation"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  AI Implementation
                </a>
              </li>
              <li>
                <a 
                  href="https://yourappwizard.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Build Your Own Phone App
                </a>
              </li>
              <li>
                <a 
                  href="https://developer.apple.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Apple Developer
                </a>
              </li>
              <li>
                <a 
                  href="https://www.amazon.com/stores/Jeffery-Long/author/B0D6LTDYD5?ref=ap_rdr&isDramIntegrated=true&shoppingPortalEnabled=true&ccs_id=043cae77-eaa8-440d-8b65-2edc56fe7c65" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Author Page
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Business Development Authority Portfolio</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://travelauthority.net/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Travel Authority
                </a>
              </li>
              <li>
                <a 
                  href="https://aiconsultingauthority.net/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  AI Consulting Authority
                </a>
              </li>
              <li>
                <a 
                  href="https://aibookauthority.net/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  AI Book Authority
                </a>
              </li>
              <li>
                <a 
                  href="https://realestatedevelopmentauthority.net/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Real Estate Development Authority
                </a>
              </li>
              <li>
                <a 
                  href="https://jefferylong.exprealty.com/" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Real Estate Development & eXp
                </a>
              </li>
              <li>
                <a 
                  href="/ca-tax-foreclosures"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  CA Tax Foreclosures
                </a>
              </li>
              <li>
                <a 
                  href="/nv-tax-foreclosures"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  NV Tax Foreclosures
                </a>
              </li>
              <li>
                <a 
                  href="/tax-foreclosures"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  All States Map
                </a>
              </li>
              <li>
                <a 
                  href="/foreclosure-recovery"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Foreclosure Recovery
                </a>
              </li>
              <li>
                <a 
                  href="https://www.etsy.com/shop/TheDownloadAuthority"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Etsy Store · TheDownloadAuthority
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg font-semibold mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <a href="/store" className="text-gray-300 hover:text-white transition-colors cursor-pointer font-semibold flex items-center gap-1.5">
                  <i className="ri-store-2-line text-sm"></i> Store
                </a>
              </li>
              <li>
                <a href="/login" className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center gap-1.5">
                  <i className="ri-user-line text-sm"></i> Sign In
                </a>
              </li>
              <li>
                <a href="/signup" className="text-gray-300 hover:text-white transition-colors cursor-pointer flex items-center gap-1.5">
                  <i className="ri-user-add-line text-sm"></i> Create Account
                </a>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <a 
                  href="/aeo-blog"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Blog
                </a>
              </li>
              <li>
                <a 
                  href="/faq"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  FAQ
                </a>
              </li>
              <li>
                <a 
                  href="/careers"
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Careers
                </a>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer"
                >
                  Contact Us
                </button>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 AI Consulting & Automation Inc. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a 
              href="/privacy-policy"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Privacy Policy
            </a>
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
